$(function () {
        // $('.all-content').css({'display':'block'});
        var allImage = $("img");
        var allImageCount = allImage.length;
        var completeImageCount = 0;


        $allImg = $('body').find('img');

        $('.animations #mv').addClass('on');
        $('.type-villain').css({ 'display': 'none' });
        animation4()
            .then(animation5)
            .done(animation6)

        $('.skip-btn').css({ 'display': 'none' });
        $('.skip-btn').css({ 'display': 'block' });
        // $('.load').removeClass('load');

        let isFirstAction = true;
        $(window).scroll(function () {
            var obj_t_pos = $('body').offset().top;
            var scr_count = $(document).scrollTop();
            var cnt = isNaN(Math.floor(obj_t_pos)) ? Math.floor(obj_t_pos) : 0; //edge対策
            if (scr_count > cnt) { // スクロール量が、指定した要素の位置を超えたら発火
                $('#pagetop-jojo').fadeIn();
                if (isFirstAction) {
                    $('#menu-group .action-text').fadeIn();
                    $('#menu-group .action-text').addClass('animated2 text-shake');
                    $('#menu-group #menu-nav img').addClass('animated shake');
                    setTimeout(function () {
                        $('#menu-group .action-text').fadeOut();
                        $('#menu-group .action-text').removeClass('animated2 text-shake');
                        $('#menu-group #menu-nav img').removeClass('animated shake');
                    }, 10000);
                    isFirstAction = false;
                }
            } else {
                $('#pagetop-jojo').fadeOut();
            }
        });

        //スムーススクロール
        $('a[href^="#"]').click(function () {
            // スクロールの速度
            var speed = 400; // ミリ秒で記述
            var href = $(this).attr("href");
            var target = $(href == "#" || href == "" ? 'html' : href);
            console.log(target);
            var position = target.offset().top;
            $('body,html').animate({ scrollTop: position }, speed, 'swing');
            $('.menu-nav').removeClass('active');
            $("#content_menu").fadeOut();
            $('body').removeClass('fixed')
            return false;
        });

        //トップへもどる
        var topBtn = $('#pagetop-jojo');
        topBtn.click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 500);
            return false;
        });

        $(window).scroll(function () {
            $('.fadein').each(function () {
                var elemPos = $(this).offset().top;
                // console.log(elemPos);
                var scroll = $(window).scrollTop();
                var windowHeight = $(window).height();
                if (scroll > elemPos - windowHeight + 200) {
                    $(this).addClass('scrollin');
                }
            });
        });


        $(window).fadeThis();

        var isScrolling = 0;
        var timeoutId;

        $(window).on("scroll touchmove", function () {
            isScrolling = 1;
            // console.log($(".zipper").offset().top);
            if ($(".zipper").offset().top > 1085) {
                $(".zipper").addClass('on')
            }

            // スクロールを停止して500ms後に終了とする
            clearTimeout(timeoutId);

            timeoutId = setTimeout(function () {
                isScrolling = 0;
                $(".zipper").removeClass('on')
            }, 500);
        });

        let promise = new Promise((resolve, reject) => { // #1
            resolve()
        })

        var scrollpos;
        $('.menu-nav').on('click', function () {
            // $('#menu-group .action-text').fadeOut();
            // $('#menu-group .action-text').removeClass('animated2 text-shake');
            // $('#menu-group #menu-nav').removeClass('animated shake');

            // if ($(this).hasClass('active')) {
            //   $(this).removeClass('active');
            //   $("#content_menu").fadeOut();
            // } else {
            //   $(this).addClass('active');
            //   $("#content_menu").fadeIn();
            // }
            // return false;
        });

        $('.skip-btn').on('click', function () {
            $(this).css({ 'display': 'none' });
            $('.animations-none').css({ 'background-image': 'none' });
            $('.animations-none').css({ 'display': 'flex' });
            $('.animations').css({ 'display': 'none' });
            $('.animations-none .main-cover').toggleClass('bk-fast');
            let promise = new Promise((resolve, reject) => { // #1
                let count = 1;
                resolve(count);
            })
            promise.then((count) => {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        $('.animations-none .main-cover').fadeOut();
                        resolve();
                    }, 1000);
                })
            }).then((count) => {
                return new Promise((resolve, reject) => {
                    $('.animations-none #mv').fadeIn();
                    $('.animations-none #mv').addClass('on');
                    resolve();
                })
            }).then((count) => {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        $('.animations-none #mv_title').fadeIn();
                        $('.animations-none #mv_title').addClass('on');
                        $('.animations-none #mv_title_sub').fadeIn();
                        $('.animations-none #mv_title_sub').addClass('on');
                        resolve();
                    }, 2000);
                })
            }).then((count) => {
                setTimeout(() => {
                    $('#menu-nav').fadeIn();
                    $('body').css({ 'overflow': 'auto' });
                    $('.all-content').css({ 'display': 'block' });
                    $('.main').removeClass('fixed');
                    $('body').removeClass('fixed').css({ 'top': 0 });
                }, 1000);
            })

        });

        function animation_c1() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c1').addClass('fadein-img');
                d.resolve();
            }, 300);
            return d.promise();
        }
        function animation_c2() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c2').addClass('fadein-img');
                d.resolve();
            }, 300);
            return d.promise();
        }
        function animation_c3() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c3').addClass('fadein-img');
                d.resolve();
            }, 300);
            return d.promise();
        }
        function animation_c4() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c4').addClass('fadein-img');
                d.resolve();
            }, 300);
            return d.promise();
        }
        function animation_c5() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c5').addClass('fadein-img');
                d.resolve();
            }, 300);
            return d.promise();
        }
        function animation_c6() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c6').addClass('fadein-img');
                d.resolve();
            }, 300);
            return d.promise();
        }

        function animation_bg() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .main-cover').toggleClass('bk');
                d.resolve();
            }, 1000);

            return d.promise();
        }

        function animation_none() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .c-layer').fadeOut();
                $('.skip-btn').css({ 'display': 'none' });
                $('.animations').css({ 'background-image': 'none' });
                d.resolve();
            }, 1500);
            return d.promise();
        }

        function animation_bg_none() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations .main-cover').fadeOut();
                d.resolve();
            }, 1000);
            return d.promise();
        }

        function animation7() {
            var d = new $.Deferred;
            $('.animations #mv').fadeIn();
            d.resolve();
            return d.promise();
        }

        function animation4() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations #mv_title').fadeIn();
                $('.animations #mv_title').addClass('on');
                d.resolve();
            }, 1500);
            d.resolve();
            return d.promise();
        }

        function animation5() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('.animations #mv_title_sub').fadeIn();
                $('.animations #mv_title_sub').addClass('on');
                d.resolve();
            }, 1500);
            d.resolve();
            return d.promise();
        }

        function animation6() {
            var d = new $.Deferred;
            setTimeout(function () {
                $('#menu-nav').fadeIn();
                $('.sns-block').css({ 'display': 'flex' });
                $('body').css({ 'overflow': 'auto' });
                $('.all-content').css({ 'display': 'block' });
                $('.main').removeClass('fixed');
                $('body').removeClass('fixed').css({ 'top': 0 });
                d.resolve();
            }, 1000);
            d.resolve();
            return d.promise();
        }

        // top content tab 切り替え
        let $tabChangeObj = $('.chenge-type-btns .btns li');
        $tabChangeObj.on('click', function () {
            let nowType = $(this).attr('id');
            console.log(nowType);
            changeType(nowType);
            $tabChangeObj.removeClass('active');
            $(this).addClass('active');
        })

    });

    function changeType(nowType) {
        let notType = (nowType == 'villain') ? 'hero' : 'villain';
        let heightType = (nowType == 'villain') ? '2500' : '6500';
        $('.type-' + notType).fadeOut();

        $('.sticky-zipper-bg').css({ 'height': heightType + 'vh' });

        $('.type-' + nowType).fadeIn(function () {
            let TypeScrollTop = $('.scroll-target-type-' + nowType).offset().top;
            $('body,html').animate({
                scrollTop: TypeScrollTop
            }, 500);
        })
    }